




















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import type { ComplexMenuSheet } from "@/@types/menu/complex-menu";
import type { ComplexMenuVariant } from "@/@types/menu/complex-menu";

import IconComponent from "@/components/app/shared/icons/icon-component.vue";
import BSwitch from "@/components/app/shared/switchs/b-switch.vue";
import BSettingDd from "@/components/app/shared/btn&dd/b-setting-dd.vue";
import DashCard from "@/components/app/shared/cards/dash-card.vue";

@Component({ components: { IconComponent, BSwitch, BSettingDd, DashCard } })
class ComplexMenuCard extends Vue {
  @Prop({ type: Object, default: null }) item!: ComplexMenuSheet | null;

  show = this.item?.show || false;

  get currentList(): ComplexMenuVariant | null {
    if (!this.item) return null;
    const variant = this.item.menu.find(
      (el) => el.variant === this.item?.current_variant
    );
    return variant ? variant : null;
  }

  @Watch("show")
  changeSheet(): void {
    if (!this.item) return;
    this.$emit("changeSheet", this.item._id, { show: this.show });
  }
}
export default ComplexMenuCard;
